import Yup from 'utils/validation';
import { GetCampaignInitialValidationObject } from 'modules/campaign-creation/utils/getCampaignCreationSetupValidation';

export type GetCampaignCreationWhatsAppValidationProps = {
  validationObject: GetCampaignInitialValidationObject;
};

export const getCampaignCreationWhatsAppValidation = ({
  validationObject
}: GetCampaignCreationWhatsAppValidationProps) => {
  const newValidationObject = Yup.object().shape({
    ...validationObject,
    templateId: Yup.string().required('This field is required')
  });

  return newValidationObject;
};
